import React from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';

const TestimonialCard = ({ rating, comment, reviewer, reviewerRole, avatar }) => {
  return (
    <Box
      sx={{
        width: 'auto',
        padding: '20px',
        backgroundColor: '#e0f7fa',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ fontSize: '1.5rem', color: '#ffc107', marginBottom: '10px' }}>
        {[...Array(rating)].map((_, index) => (
          <StarRateRoundedIcon key={index} />
        ))}
      </Box>
      <Typography
        sx={{
          fontFamily: '"Montserrat", Lato',
          fontSize: '16px',
          fontWeight: 500,
          fontStyle: 'italic',
          lineHeight: '28.8px',
          color: '#121212B3',
          marginBottom: '30px',
        }}
      >
        "{comment}"
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <Avatar
          src={avatar}
          alt={reviewer}
          sx={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '10px' }}
        />
        <Box sx={{ textAlign: 'left' }}>
          <Typography component="strong" sx={{ display: 'block', fontSize: '1rem', color: '#333' }}>
            {reviewer}
          </Typography>
          <Typography component="span" sx={{ fontSize: '0.8rem', color: '#666' }}>
            {reviewerRole}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialCard;
